"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.move = exports.removeUser = exports.removeGroup = exports.handleCreateAndUpdateUserGroup = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/customer/userGroups");
const Actions = require("../../actions/customer/userGroups");
const _usergroupListActions = require("../../modules/usergroup/list/actions");
const usergroupListActions = _usergroupListActions.default('customer/user-groups');
function handleCreateAndUpdateUserGroup(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_EDIT_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: request.payload.mode === 'CREATE' ? 'POST' : 'PUT',
            body: {
                type: request.payload.type,
                name: request.payload.name,
                id: request.payload.id,
                categoryId: request.payload.categoryId
            },
            url: `${baseUrl}api/user-group/customer/${request.payload.customerId}/group${request.payload.mode === 'EDIT' ? `/${request.payload.id}` : ''}`
        }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.createEditSuccess(), usergroupListActions.fetchRequest('CUSTOMER_USER_GROUPS', request.payload.customerId))), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createEditFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleCreateAndUpdateUserGroup = handleCreateAndUpdateUserGroup;
function removeGroup(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_GROUP_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            url: `${baseUrl}api/user-group/customer/${request.payload.customerId}/group/${request.payload.group.id}`
        }).pipe((0, operators_1.mergeMap)((response) => {
            if (response.status === 200) {
                const act = [Actions.removeGroupSuccess()];
                act.push(usergroupListActions.fetchRequest('CUSTOMER_USER_GROUPS', request.payload.customerId));
                return (0, rxjs_1.of)(...act);
            }
            return (0, rxjs_1.of)(Actions.removeGroupFailed((0, errorHandling_1.parseAjaxErrorResponse)(response)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.removeGroupFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.removeGroup = removeGroup;
function removeUser(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_USER_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            url: `${baseUrl}api/user-group/member`,
            body: request.payload.items.map((x) => ({
                userId: x.user.id,
                groupId: x.group.id
            }))
        }).pipe((0, operators_1.mergeMap)((response) => {
            if (response.status === 200) {
                const act = [Actions.removeUserSuccess()];
                act.push(usergroupListActions.fetchRequest('CUSTOMER_USER_GROUPS', request.payload.customerId));
                return (0, rxjs_1.of)(...act);
            }
            return (0, rxjs_1.of)(Actions.removeUserFailed((0, errorHandling_1.parseAjaxErrorResponse)(response)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.removeUserFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.removeUser = removeUser;
function move(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.MOVE_USER_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            url: `${baseUrl}api/user-group/move-member`,
            body: {
                targetGroupId: request.payload.target.id,
                users: request.payload.users.map((x) => ({
                    userId: x.user.id,
                    currentGroupId: x.currentGroup ? x.currentGroup.id : undefined
                }))
            }
        }).pipe((0, operators_1.mergeMap)((response) => {
            if (response.status === 200) {
                const act = [Actions.moveUserSuccess()];
                act.push(usergroupListActions.fetchRequest('CUSTOMER_USER_GROUPS', request.payload.customerId));
                return (0, rxjs_1.of)(...act);
            }
            return (0, rxjs_1.of)(Actions.moveUserFailed((0, errorHandling_1.parseAjaxErrorResponse)(response)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.moveUserFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.move = move;
//# sourceMappingURL=userGroups.js.map